<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve"  :width="width" :height="height" :fill="fillColor">
        <g>
            <path d="M50.5,104.4c-2.6,0.3-5.5,0.9-8.3,0.9c-1.2,0-2.7-0.9-3.4-1.8c-0.8-1,0.1-2.1,1.2-2.9c0.6-0.5,0.6-1.6,1-2.4
                c4.2-7.6,8.3-15.2,12.6-22.7c1.8-3.2,4.9-4.5,8.5-4.6c13.8-0.6,27.6-1.2,41.4-1.9c1.5-0.1,3-0.3,4.1-0.4c0-4,0-7.7,0-12.5
                c0.6-1.1,2.5-1.8,4.8-1.7c4.4,0.1,8.7,0,13.2,0c0.9,0.5,0.2,1.5,0,1.6c-3,1.9-1.5,4.9-1.9,7.4c-0.2,1.4,0,2.9,0,4.4
                c3.4,0,6.9,0.1,10.4,0c2.6-0.1,4.6,0.9,5.9,3c2.8,4.4,5.5,8.8,8.1,13.3c2.1,3.6,4.2,7.3,6.2,11c0.2,0.4,0.5,0.7,0.7,1.1
                c0.6,1.1,1.8,2.8,1.5,3.2c-1.5,1.6-3,3.4-5.8,2.7c-2-0.4-4.2-0.1-6.6-0.1c0.5,28.9,2.4,57.2,0.2,85.7c-0.4,3.8-8.9,2.9-13.8,2.9
                c-5.8,0.1-11.6,0.6-17.4,0.7c-7.8,0.2-15.6,0.2-23.4,0.1c-9.4-0.1-18.9-0.3-28.3-0.5c-2,0-4-0.4-5.9-0.7c-1.9-0.3-3.3-2.5-3.3-4.4
                c-0.3-7.8-0.7-15.5-1-23.3C51,157,51,151.6,51,146.2c0-11.1,0.1-22.2,0-33.3C51,110.1,50.7,107.4,50.5,104.4z M57.2,186.2
                c14.8,0.3,29.4,0.6,43.6,0.9c0-4.2,0-7.8,0-11.4c0.1-7.4,0.3-14.8,0.5-22.2c0-0.7,0.5-1.9,0.9-2c2.1-0.4,4.2-0.6,6.3-0.7
                c5.6-0.4,11.3-0.7,17-1c0.4,0,1,0.3,1.2,0.4c1.5,1,1.6,2.7,1.6,4.1c0.2,5.3,0.1,10.6,0.1,15.9c0,5.2,0,10.4,0,15.7
                c3.1,0,6.4,0.1,9.7-0.1c0.6,0,1.6-1,1.6-1.6c0.3-2.5,0.6-5,0.5-7.5c-0.4-17.1-1-34.2-1.3-51.3c-0.2-7.2,0-14.4,0-22.3
                c-28.5,3.3-56.6,3.2-84.2,0.9C57,131.6,55.2,158.6,57.2,186.2z M45.2,100.8c0.2,0.2,0.4,0.3,0.6,0.5c1.2-0.3,2.4-0.7,3.5-0.8
                c5.4-0.2,10.8-0.6,16.3-0.4c8.4,0.2,16.8,1.3,25.1,1.2c10.5-0.1,21.1-0.9,31.6-1.5c9.4-0.6,18.7-1.3,28.5-2
                c-1.5-2.3-3.1-4.4-4.4-6.7c-3.5-5.8-7-11.6-10.4-17.5c-1-1.7-2-2.4-4-2.2c-4.4,0.4-8.7,0.3-13.1,0.6c-6.5,0.4-13.1,1.1-19.6,1.5
                c-10.6,0.6-21.3,1-31.9,1.5c-2.8,0.1-5.6,0.4-7.9,0.6C54.6,84.1,49.9,92.5,45.2,100.8z M123.9,186.1c0-2.2,0-2.1,0-2.9
                c-0.2-7.2-0.4-14.5-0.5-21.7c-0.1-2.8,0-5.5,0-7.9c-6.2,0.5-12.1,0.9-18.3,1.3c0,10.5,0,21.1,0,31.4
                C111.5,186.3,117,186.1,123.9,186.1z M119.8,67.9c0-3,0.2-7.3,0-10c0,0-1,0-1.5,0c-2.1,0-4.2,0.4-6.7,0.7c0,3.1,0,6.2,0,9.3
                C114.4,67.9,117.2,67.9,119.8,67.9z"/>
            <path d="M128.1,135.7c-3,0.2-5.1,0.5-7.2,0.5c-5.4,0.1-10.8,0-16.2,0c-1.4,0-1.9-0.4-2-2.3c-0.2-6.3-0.9-12.6-1.4-19
                c-0.2-2.2,0.9-2.9,3.3-2.7c2,0.2,4.1-0.1,6.2-0.2c3.3-0.1,6.7-0.1,10-0.3c1,0,3.1,0,4.1-0.3c1-0.2,2.4-0.5,2.8,1.2
                c0.5,2.1,0.1,3.5,0.2,5.7C128.3,124.4,128.1,130.4,128.1,135.7z M123.6,122.3c-5.2,0-10.2-0.1-15.1,0.1c-1.9-0.1-2.1,0.4-2.2,1.7
                c0,2.3,0.3,4.7,0.4,7c0,0.5,0.9,1.3,1.4,1.3c1.8,0.2,3.6,0.1,5.4,0.1c3.4,0,6.8,0,10.1,0C123.6,128.8,123.6,125.4,123.6,122.3z
                    M123.2,115.5c-5.6,0.3-11,0.6-16.7,1c-0.9,0.1-0.6,2.6-0.2,2.6c5.6,0,11.5,0,16.9,0C123.2,118,123.2,116.6,123.2,115.5z"/>
            <path d="M65.7,115.4c0-2.9,9-1.8,13.7-2c2.1-0.1,4.1,0,6.2-0.1c3.2-0.1,5.1,1.3,5.2,4.4c0.2,4.6,0.3,9.1,0.4,13.7
                c0,1.4-0.4,2.7-0.5,3.6c0,0.8-1.7,0.8-2.4,1c-1.5,0.4-3.1,0.6-4.6,0.8c-4.7,0.6-9.3,1.4-14,1.6c-3.9,0.2-5.1-1.2-4.9-5.1
                C65,127.4,65.4,121.4,65.7,115.4z M86.6,122.6c-1.1,0-1.9-0.1-2.7,0c-3.6,0.3-7.2,0.7-10.9,0.9c-3.4,0.2-3.4,0-3.4,3.4
                c-0.1,2.6-0.3,5.2-0.5,8.2c6.2-0.8,11.9-1.5,17.5-2.3C86.6,129.4,86.6,126.2,86.6,122.6z M86.1,117.5c-5.2,0-10.1,0-15.1,0.1
                c-1.6-0.1-1.6-0.1-1.7,1.3c0.1,0.2,0.3,0.4,0.4,0.6c5.4,0,10.8,0,16.3,0C86.1,118.7,86.1,117.9,86.1,117.5z"/>
            <path d="M88,171.6c-3.8,0.2-7.4,0.5-11,0.6c-2.6,0.1-5.3-0.1-7.9-0.3c-3.2-0.2-4.1-1.7-4-4.9c0.2-4.9,0.1-9.8,0-14.8
                c0-2.1,0-3.1,2.9-3.8c5.3-1.5,10.5-1.4,15.8-1.6c3.3-0.2,4.9,1.2,5.3,4.3C89.7,158,89.3,164.9,88,171.6z M84.8,155.5
                c-4.7,0.6-9,1.2-13.3,1.7c-1.3,0.1-1.9,0.5-1.9,1.9c0,2.5-0.2,5.1-0.2,7.6c0,0.5,0.6,1.4,0.9,1.4c4.4,0.3,9.9,0.5,14.5,0.7
                C85.2,164,84.4,159.7,84.8,155.5z M69.2,153.6c3.8-0.2,6.9-0.2,10-0.5c1.4-0.1,5.5-0.5,5.5-0.5c0.3-0.8,0-2.3-0.5-2.2
                c-4.1,0.3-10.7,0.5-14.7,1C69.4,151.5,69.4,151.5,69.2,153.6z"/>
            <path d="M121.3,173.2c-0.4,0.9-0.5,1.8-2.1,2.3c-1,0-1.8-0.7-2-1.6c-0.2-0.8,0-2.2,1.4-2.9C120.6,170.9,121.3,171.7,121.3,173.2z"/>
        </g>
</svg>

</template>

<script>
export default {
    props: {
        width: {
            type: [Number, String],
            default: '205px',
        },
        height: {
            type: [Number, String],
            default: '167px',
        },
        fillColor: {
            type: String,
            default: '#262323',
        },
    },
};
</script>
